import { Flex, Text } from "@chakra-ui/react";
import IconSilverTicket from "components/IconSilverTicket/IconSilverTicket";
import { IconDoubleArrow, IconGoldenTicket, IconLeaderboard } from "icons";

const LeaderboardAccordionPanel = () => {
  return (
    <Flex
      w="full"
      alignItems="center"
      gap="2"
    >
      <Flex
        flexDir="column"
        alignItems="center"
        flex={1}
      >
        <Text
          fontSize={{ base: '10px', md: '12px' }}
          lineHeight={{ base: '12px', md: '14px' }}
          fontWeight={600}
          color="white.60"
          textTransform="uppercase"
          textAlign={{ base: 'center', md: 'left' }}
        >
          EARN POINTS PER RACE
        </Text>
        <Flex
          background="linear-gradient(360deg, rgba(227, 227, 227, 0.2) 0%, rgba(227, 227, 227, 0) 100%)"
          borderRadius="4px"
          px="4"
          py="2"
          minH="45px"
          position="relative"
          w="full"
          justifyContent="center"
          borderTop="none"
          _before={{
            content: '""',
            position: "absolute",
            inset: 0,
            borderRadius: "4px",
            padding: "2px",
            paddingTop: "0px",
            borderWidth: "0px 1.5px 1.5px 1.5px",
            background: "linear-gradient(360deg, rgba(227, 227, 227, 0.48) 0%, rgba(227, 227, 227, 0) 100%)",
            mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
            maskComposite: "exclude",
          }}
        >
          <Flex
            flexDirection={{ base: 'column', md: 'row' }}
            alignItems="center"
            gap={4}
            zIndex={2}
            background={"linear-gradient(225deg, #FFFFFF 0%, #EEEEEE 18%, #A0A0A0 73%, #979797 100%)"}
            borderTopRightRadius="12px"
            borderTopLeftRadius="2px"
            borderBottomLeftRadius="12px"
            borderBottomRightRadius="2px"
            p="1"
          >
            <IconLeaderboard
              boxSize={4}
              __css={{
                path: {
                  fill: 'black.80'
                }
              }}
            />

          </Flex>
        </Flex>
      </Flex>

      <IconDoubleArrow mt="2" />

      <Flex
        flexDir="column"
        alignItems="center"
        flex={1}
      >
        <Text
          fontSize={{ base: '10px', md: '12px' }}
          lineHeight={{ base: '12px', md: '14px' }}
          fontWeight={600}
          color="white.60"
          textTransform="uppercase"
          textAlign={{ base: 'center', md: 'left' }}
        >
          WIN TOURNAMENT ENTRY
        </Text>
        <Flex
          background="linear-gradient(360deg, rgba(255, 238, 88, 0.2) 0%, rgba(255, 238, 88, 0) 100%)"
          borderRadius="4px"
          px="4"
          py="1"
          borderTop="none"
          position="relative"
          minH="45px"
          w="full"
          _before={{
            content: '""',
            position: "absolute",
            inset: 0,
            borderRadius: "4px",
            padding: "2px",
            paddingTop: "0px",
            borderWidth: "0px 1.5px 1.5px 1.5px",
            background: "linear-gradient(360deg, rgba(255, 238, 88, 0.48) 0%, rgba(255, 238, 88, 0) 100%)",
            mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
            maskComposite: "exclude",
          }}
        >
          <Flex
            width="full"
            height="full"
            alignItems="center"
            justifyContent="center"
          >
            <IconSilverTicket 
              width={{ base: '1.9rem', md: '2.25rem' }}
              height={{ base: '1.9rem', md: '2.25rem' }}
            />
            <IconGoldenTicket 
              width={{ base: '2rem', md: '2.25rem' }}
              height={{ base: '2rem', md: '2.25rem' }}
            />
          </Flex>
        </Flex>
      </Flex>

      <IconDoubleArrow mt="2" />

      <Flex
        flexDir="column"
        alignItems="center"
        flex={1}
      >
        <Text
          fontSize={{ base: '10px', md: '12px' }}
          lineHeight={{ base: '12px', md: '14px' }}
          fontWeight={600}
          color="white.60"
          textTransform="uppercase"
          textAlign={{ base: 'center', md: 'left' }}
          whiteSpace={{ base: 'pre-line', md: 'nowrap' }}
        >
          {'WIN \nREWARDS'}
        </Text>
        <Flex
          background="linear-gradient(360deg, rgba(79, 197, 186, 0.2) 0%, rgba(79, 197, 186, 0) 100%)"
          borderRadius="4px"
          px="4"
          py="2"
          borderTop="none"
          position="relative"
          minH="45px"
          w="full"
          justifyContent="center"
          _before={{
            content: '""',
            position: "absolute",
            inset: 0,
            borderRadius: "4px",
            padding: "2px",
            paddingTop: "0px",
            borderWidth: "0px 1.5px 1.5px 1.5px",
            background: "linear-gradient(360deg, rgba(79, 197, 186, 0.48) 0%, rgba(79, 197, 186, 0) 100%)",
            mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
            maskComposite: "exclude",
          }}
        >
          <Text
            fontSize="20px"
            lineHeight="24px"
            fontWeight={600}
            color="treasuredTeal.100"
          >
            $100+
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
};

export default LeaderboardAccordionPanel;
